<template>
  <v-container>
    <v-dialog
        max-width="700"
        scrollable
        v-model="paymentMethodsDialog"
    >
      <PaymentMethodsModal
          @close="paymentMethodsDialog = false"
          :totalAmountOrdered="totalOrder"
          :installments="parcelas"
      ></PaymentMethodsModal>
    </v-dialog>
    <v-form
        action="javascript:void(0);"
        method="POST"
        data-pagarmecheckout-form
        ref="firstForm"
    >
      <v-row cols="12" class="ma-0  ">
        <v-col cols="12" sm="12">
          <v-card class="itens-card">
            <div class="d-flex align-center">
              <v-icon size="33" color="normalred" class="mr-2">
                mdi-file-document-multiple-outline
              </v-icon>
              <strong class="delivery-text">Resumo da compra</strong>
            </div>

            <div>
              <Course
                  :course="course"
                  :layout="isMobile ? 'vertical': 'horizontal'"
              ></Course>
            </div>
            <div>
              <CourseGroup
                  :courseGroups="courseGroups"
              ></CourseGroup>
            </div>
          </v-card>
        </v-col>

        <v-col v-if="orderCourse && orderCourse.id && paymentMethod == creditCard && (orderCourse.status == statusCanceled || orderCourse.status == statusRefused)" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-card class="itens-card">
            <p><strong style="color: #bc0000">Atenção: </strong> <span v-html="messageRefusedCanceled"></span> </p>

            <ul style="margin-left: -10px">
              <li>
                <strong>Dados do Cartão: </strong>
                <span>Confirme se o número, a data de validade e o código de segurança (CVV) do cartão estão inseridos corretamente.</span>
              </li>
              <li>
                <strong>Limite: </strong>
                <span>Verifique junto ao seu banco se o limite do cartão foi excedido ou se há algum bloqueio para compras online.</span>
              </li>
            </ul>

            <p class="mt-2">
              <strong>
                Se preferir, você também pode finalizar a compra imediatamente usando outros métodos de pagamento:
              </strong>
            </p>

            <ul style="margin-left: -10px">
              <li>
                <strong>Pix: </strong>
                <span>Pagamento instantâneo, confirmação rápida.</span>
              </li>
              <li>
                <strong>Boleto Bancário: </strong>
                <span>O pagamento será confirmado em até 2 a3 dias úteis.</span>
              </li>
            </ul>
          </v-card>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
          <v-row class="ma-0" no-gutters>
            <v-col cols="12">
              <v-card class="itens-card">
                <div class="d-flex align-center mb-4">
                  <v-icon color="normalred" size="33" class="mr-2">
                    mdi-credit-card-multiple-outline
                  </v-icon>
                  <strong class="delivery-text">Formas de pagamento</strong>
                </div>

                <p
                    class="mb-0"
                    style="
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 32px;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Escolha uma forma de pagamento
                </p>

                <v-row cols="12" class=" ">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <v-card
                        class="pa-3 mt-3 d-flex flex-column"
                        :class="paymentMethod == 0 ? 'active-card' : ''"
                        outlined
                        style="border-radius: 10px"
                        flat
                        @click="paymentMethod = 0"
                    >
                      <div class="d-flex align-center">
                        <v-btn small icon>
                          <v-icon
                              :color="paymentMethod == 0 ? 'normalred' : ''"
                          >
                            {{
                              paymentMethod == 0
                                  ? "mdi-circle-slice-8"
                                  : "mdi-checkbox-blank-circle-outline"
                            }}
                          </v-icon>
                        </v-btn>
                        <v-icon
                            class="mr-2"
                            size="20"
                            :color="paymentMethod == 0 ? 'normalred' : ''"
                        >
                          mdi-credit-card-outline
                        </v-icon>
                        <strong
                            :style="paymentMethod == 0 ? 'color: #BC0000' : ''"
                        >
                          Cartão de crédito
                        </strong>
                      </div>

                      <div class="d-flex align-center">
                        <v-img
                            class="mr-2"
                            src="../../../../assets/payments.svg"
                            max-width="160"
                            contain
                        ></v-img>
                        <span>e mais...</span>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <v-card
                        class="pa-3 mt-3 d-flex flex-column"
                        outlined
                        :class="paymentMethod == 2 ? 'active-card' : ''"
                        style="border-radius: 10px"
                        flat
                        @click="paymentMethod = 2"
                    >
                      <div class="d-flex align-center">
                        <v-btn
                            small
                            icon
                            :color="paymentMethod == 2 ? 'normalred' : ''"
                        >
                          <v-icon>
                            {{
                              paymentMethod == 2
                                  ? "mdi-circle-slice-8"
                                  : "mdi-checkbox-blank-circle-outline"
                            }}
                          </v-icon>
                        </v-btn>
                        <div>
                          <v-img
                              :src="
                              paymentMethod == 2
                                ? require('../../../../assets/pix-red.svg')
                                : require('../../../../assets/pix.svg')
                            "
                              max-height="20"
                              contain
                          ></v-img>
                        </div>
                        <strong
                            :style="paymentMethod == 2 ? 'color: #BC0000' : ''"
                        >
                          Pix
                        </strong>
                      </div>

                      <div class="d-flex align-center">
                        <span> Aprovação imediata do pagamento </span>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
                    <v-card
                        class="pa-3 mt-3 d-flex flex-column"
                        :class="paymentMethod == 1 ? 'active-card' : ''"
                        outlined
                        style="border-radius: 10px"
                        flat
                        @click="paymentMethod = 1"
                    >
                      <div class="d-flex align-center">
                        <v-btn
                            small
                            icon
                            :color="paymentMethod == 1 ? 'normalred' : ''"
                        >
                          <v-icon>
                            {{
                              paymentMethod == 1
                                  ? "mdi-circle-slice-8"
                                  : "mdi-checkbox-blank-circle-outline"
                            }}
                          </v-icon>
                        </v-btn>
                        <div>
                          <v-img
                              :src="
                              paymentMethod == 1
                                ? require('../../../../assets/boleto-red.svg')
                                : require('../../../../assets/boleto-icon.svg')
                            "
                              max-height="20"
                              contain
                          ></v-img>
                        </div>
                        <strong
                            :style="paymentMethod == 1 ? 'color: #BC0000' : ''"
                        >
                          Boleto Bancário
                        </strong>
                      </div>

                      <div class="d-flex align-center">
                        <span>
                          2 a 3 dias úteis para compensação do pagamento.
                        </span>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-expand-transition>
                  <div v-if="paymentMethod == 0">
                    <v-divider class="my-3"></v-divider>

                    <v-row>
                      <v-col cols="12">
                        <strong>Número do cartão</strong>
                        <v-text-field
                            color="normalred"
                            class="elevation0 elevation-0"
                            name="card-number"
                            data-pagarmecheckout-element="number"
                            background-color="#F2F2F2"
                            dense
                            hide-details="auto"
                            filled
                            rounded
                            style="border-radius: 6px !important"
                            v-mask="['#### #### #### ####']"
                            placeholder="0000.0000.0000.000"
                            v-model="card.card_number"
                            required
                            :rules="[rules.required]"
                        />
                      </v-col>

                      <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                        <strong>Validade (mês/ano)</strong>
                        <v-text-field
                            color="normalred"
                            name="card-exp-date"
                            data-pagarmecheckout-separator="-"
                            data-pagarmecheckout-element="exp_date"
                            dense
                            hide-details="auto"
                            placeholder="MM-AA"
                            v-mask="['##-##']"
                            v-model="card.card_expiration_date"
                            required
                            :rules="[rules.required]"
                            filled
                            rounded
                            style="border-radius: 6px !important"
                        />
                      </v-col>

                      <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                        <strong>Código de Segurança (CVV)</strong>
                        <v-text-field
                            color="normalred"
                            name="cvv"
                            data-pagarmecheckout-element="cvv"
                            dense
                            hide-details="auto"
                            placeholder="000"
                            v-mask="['####']"
                            v-model="card.card_cvv"
                            :rules="[rules.required]"
                            required
                            filled
                            rounded
                            style="border-radius: 6px !important"
                        />
                      </v-col>

                      <v-col cols="12">
                        <strong>Nome Completo (conforme impresso no cartão)</strong>
                        <v-text-field
                            color="normalred"
                            name="holder-name"
                            data-pagarmecheckout-element="holder_name"
                            dense
                            hide-details="auto"
                            placeholder="Nome e sobrenome"
                            v-model="card.card_holder_name"
                            required
                            :rules="[rules.required]"
                            filled
                            rounded
                            style="border-radius: 6px !important"
                        />
                      </v-col>
                    </v-row>

                    <v-row cols="12">
                      <v-col cols="12" xs="12" sm="7" md="8" lg="8" xl="8">
                        <strong>Número de Parcelas</strong>
                        <v-select
                            color="normalred"
                            dense
                            placeholder="Selecione o número de parcelas"
                            :items="parcelas"
                            hint="Preencha os dados do cartão para alterar o número de parcelas"
                            persistent-hint
                            item-text="name"
                            item-value="value"
                            append-icon="mdi-chevron-down"
                            v-model="creditInstallments"
                            required
                            :rules="[rules.required]"
                            filled
                            rounded
                            style="
                            border-radius: 6px !important;
                            text-transform: none !important;
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <v-card class="itens-card">
            <div
                class="mt-3 pa-3"
                style="background: #f2f2f2; border-radius: 3px"
            >
              <div class="d-flex">
                <strong class="item-text">Curso</strong>
                <v-spacer></v-spacer>
                <strong class="item-text">
                  {{ formatCurrency(total) }}
                </strong>
              </div>

              <br/>

              <div class="d-flex">
                <strong
                    class="item-text"
                    style="color: #bc0000 !important; font-weight: 700"
                >
                  Total
                </strong>
                <v-spacer></v-spacer>
                <strong
                    class="item-text"
                    style="color: #bc0000 !important; font-weight: 700"
                >
                  {{ formatCurrency(totalOrder) }}
                </strong>
              </div>

              <div class="d-flex justify-end">
                <strong
                    style="font-size: 12px" class="item-text mt-2"
                    v-if="creditInstallments > 1 && paymentMethod === creditCard"
                >
                  {{ parcelas.find((x) => x.value === creditInstallments).name }} de {{
                    (totalOrder / creditInstallments).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </strong>
              </div>

              <div class="mt-2">
                <a class="formas-pagamento" @click="paymentMethodsDialog = true">
                  Mais formas de pagamento
                </a>
              </div>
            </div>

            <v-btn
                block
                type="submit"
                color="normalred"
                class="mt-5"
                depressed
                :loading="loading"
                @click="validateFields"
                :disabled="!isThereSlots"
            >
              <div class="d-flex align-center" style="text-transform: none">
                <v-icon class="mr-2"> mdi-shield-check</v-icon>
                <strong>Finalizar compra</strong>
              </div>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<style scoped>
.title-toolbar {
  font-weight: 500;
  font-size: 18px;
  margin-top: 7px;
}

.date {
  font-weight: 700;
}

.active-card {
  border: 1px solid #bc0000 !important;
  box-shadow: 0px 12px 20px rgba(14, 31, 53, 0.12) !important;
}

.item-text {
  font-weight: 500;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}

.itens {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;
}

.itens::-webkit-scrollbar {
  width: 7px;
  background: #d9d9d9;
  border-radius: 4px;
}

.itens::-webkit-scrollbar-thumb {
  background: #a7a7a7;
  border-radius: 4px;
}

.delivery-text {
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  color: #2d3038;
}

.itens-card {
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
  padding: 24px;
}
</style>

<style scoped>
.formas-pagamento {
  color: #000000;
  text-decoration: underline;
}

.totalOder {
  font-weight: bold;
  text-align: right;
}

.installments {
  font-size: 12px;
  font-weight: bold;
}

.forma-pagamento-row {
  text-align: left;
  margin: 0 0 0 10px !important;
}

.fechar-pedido {
  text-align: center;
  font-size: x-large;
  margin-top: -20px !important;
  padding-bottom: 20px !important;
}

.btn-fechar-pedido {
  height: 41px !important;
  border-radius: 5px !important;
}

.desconto-frete {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #000000;
}

.price {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.15px;

  color: #000000;
}

.qty-product {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #000000;
}

.qty-name {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.15px;
  text-transform: uppercase;
  color: #000000;
}

.parcelas {
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #000000;
}

.total-pedido {
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  width: 100%;
  border-top: 1px solid #000000;
  padding: 10px 0;
}

.itens-pedido {
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.desconto-pedido {
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.frete-pedido {
  justify-content: space-between;
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
}

.total {
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #000000;
}

.sombra {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
}

.sucess-coupon {
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;

  color: #8dc63f;
}

.error-coupon {
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #ec1313;
}

.coupon-button {
  width: 50% !important;
  height: 50px;
  background: rgba(196, 196, 196, 0.5);
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 4px;
}

.coupon-button:hover {
  background: #bc0000 !important;

  color: white !important;
}

.span-details {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: #2d3038;
}

.span-details:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.span-order {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
}

.cabeca {
  border-start-end-radius: inherit;
  border-start-start-radius: inherit;
  display: flex;
  justify-content: space-between;
}

.checkbox-mobile {
  margin-top: -10px !important;
  margin-bottom: 10px !important;
}

.no-pointer {
  cursor: auto !important;
}

.label {
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #c4c4c4;
}

.pad-mobile {
  padding: 10px !important;
}

.pad-all {
  padding: 0px 45px 45px 45px !important;
}

.radio-text {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  margin-left: -10px !important;
  color: #000000;
}

.v-input--radio-group {
  flex-direction: row !important;
}

.cards {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 8px !important;
  height: 300px !important;
}

.voltar-btn {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 14px;
  letter-spacing: 0.15px;
  color: #000000;
}

.voltar-btn:hover {
  cursor: pointer;
}

.label-right {
  cursor: pointer;
  color: #000000;
  justify-content: space-between !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 32px;
}

.radio {
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 6px;
  width: 230px !important;
  min-height: 80px !important;
  margin-left: -10px !important;
  padding-left: 10px !important;
}

.span-title {
  padding-top: 12px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;

  color: rgba(0, 0, 0, 0.5);
}

.mainCheckout {
  padding-top: 5px !important;
  max-width: unset !important;
  text-align: -webkit-center;
  background-color: #f5f5f5;
}

#mainCheckout {
  font-family: Roboto, serif !important;
}

@media (max-width: 1080px) {
  .radio {
    width: 105% !important;
    height: 65px !important;
  }
}

@media (max-width: 960px) and (min-width: 768px) {
  /*.total-pedido {
    padding: 0 40px !important;
  }*/
}

@media (max-width: 660px) {
  .pad-all {
    padding: 0px 0px 0px 0px !important;
  }

}

.hidden-mobile {
  display: none;
}

@media (max-width: 960px) {
  .hidden-mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .margin-top {
    margin-top: -22px !important;
  }

  .forma-pagamento-row {
    width: 95% !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Utils from "../../../../Utils/ValidateCPFCNPJ";
import moment from "moment";
import FormatDate from "../../../../Utils/FormatDate";
import FormatCurrency from "../../../../Utils/FormatCurrency";
import CourseGroup from "../CourseGroup.vue";
import PaymentMethodsModal from "../../components/PaymentMethodsModal.vue";
import Course from "../Course.vue";

export default {
  name: "Checkout",
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {passive: true});
    }
    clearInterval(this.interval);
  },

  components: {Course, PaymentMethodsModal, CourseGroup},

  data: () => ({
    coupon: null,
    pagarmetokens: {},
    total: 0,
    paymentMethod: 0,
    discount: 0,
    order: [],
    taxaJuros: 5,
    creditCard: 0,
    paymentMethodsDialog: false,
    parcelas: [
      {name: "Em 1x sem juros", value: 1, totalAmountOrdered: 0},
      {name: "Em 2x sem juros", value: 2, totalAmountOrdered: 0},
      {name: "Em 3x sem juros", value: 3, totalAmountOrdered: 0},
      {name: "Em 4x sem juros", value: 4, totalAmountOrdered: 0},
      {name: "Em 5x sem juros", value: 5, totalAmountOrdered: 0},
      {name: "Em 6x sem juros", value: 6, totalAmountOrdered: 0},
      {name: "Em 6x sem juros", value: 7, totalAmountOrdered: 0},
      {name: "Em 6x sem juros", value: 8, totalAmountOrdered: 0},
      {name: "Em 6x sem juros", value: 9, totalAmountOrdered: 0},
      {name: "Em 6x sem juros", value: 10, totalAmountOrdered: 0},
    ],
    apiService: new ApiService(),
    isMobile: false,
    src: "",
    isBoleto: false,
    loading: false,
    orderCanBeWithdrawn: false,
    deniedPaymentDialog: false,
    confirmOrder: false,
    approvePaymentDialog: false,
    confirmPaymentDialog: false,
    selectAddressDialog: false,
    creditInstallments: 1,
    phone: "",
    document: "",
    card: {
      card_holder_name: "",
      card_number: "",
      card_expiration_date: "",
      card_cvv: "",
    },
    couponTypeCategory: 3,
    couponTypetypeSubcategory: 4,
    couponTypetypeProduct: 5,
    benefitPercentual: 1,
    benefitReais: 2,
    radioGroup: 0,
    radioGroup2: "",
    env: process.env.VUE_APP_BASE_URL,
    rules: {
      min: (value) => value.length >= 14 || "Telefone invalido.",
      required: (value) => !!value || "Campo requerido.",
      validateCPF: (value) =>
          Utils.CPF(value) ||
          value.toString().replace(/\D/g, "").length > 11 ||
          "Cpf Inválido",
      validateCNPJ: (value) =>
          Utils.CNPJ(value) ||
          value.toString().replace(/\D/g, "").length <= 11 ||
          "Cnpf Inválido",
    },
    percentageDiscountForApplicators: 0,
    student: Object,
    user: Object,
    curso_combo: null,
    id: null,
    isThereSlots: true,
    course: Object,
    combo: Object,
    periods: [
      {name: "Matutino", value: "0"},
      {name: "Vespertino", value: 1},
      {name: "Noturno", value: 2}
    ],
    levels: [
      {name: "Iniciante", value: "0"},
      {name: "Intermediário", value: 1},
      {name: "Avançado", value: 2}
    ],
    daysOfTheWeek: [
      {name: "Domingo", value: 0},
      {name: "Segunda", value: 1},
      {name: "Terça", value: 2},
      {name: "Quarta", value: 3},
      {name: "Quinta", value: 4},
      {name: "Sexta", value: 5},
      {name: "Sábado", value: 6}
    ],
    statusPending: 0,
    statusPaid: 1,
    statusRefused: 2,
    statusCanceled: 3,
    messageRefusedCanceled: 'Informamos que o pagamento do seu pedido não foi autorizado. <br/>O pagamento pode ser recusado por diversos motivos, por exemplo: se o limite do cartão tiver sido excedido, se sua compra estiver fora da faixa de gastos comum, se seu banco tiver políticas especiais para compras online, ou se as informações do seu cartão de crédito (número ou data de validade) tiverem sido inseridas incorretamente em Sua Conta. Se necessário, entre em contato com seu banco para mais informações',
    orderCourse: Object,
    courseGroup: Object,
    courseGroups: [],
    courseLinkSearch: null,
    courseGroupId: null,
    baseUrl: null,
    orderCourseGroupId: null,
    interval: null,
  }),

  async mounted() {
    try {
      this.env = process.env.VUE_APP_BASE_URL;
      this.user = JSON.parse(localStorage.getItem("user"));

       if (this.user) {
         await this.getStudent()
       } else {
         await this.goToRoute('/login')
         return
       }

      this.onResize();
      window.addEventListener("resize", this.onResize, {passive: true});
      const {courseLinkSearch, courseGroupId} = this.$route.params
      this.courseLinkSearch = courseLinkSearch
      this.courseGroupId = courseGroupId
      await this.getCourse()
      await this.getCourseGroup()
      if(!this.course || !this.course.id || !this.courseGroup || !this.courseGroup.id){
        await this.$router.go(-1)
      }
      this.baseUrl = window.location.origin
    } catch (e) {
    }
  },
  async created() {

  },

  watch: {},

  computed: {
    totalOrder() {
      let total = 0;
      if (this.course && this.course.id) {
        total += this.course.price
        this.updateInstallmentValue(total);
        total += this.calculateTotalInterestPerProduct(this.creditInstallments)
      }
      return total;
    }
  },

  methods: {
    async getCourse() {
      try {
        const {content} = await this.apiService.get(`course/linkSearch/${this.courseLinkSearch}`)
        this.course = content
        this.total = this.course.price
      } catch (e) {

      }
    },

    async getCourseGroup() {
      try {
        const {content} = await this.apiService.get(`courseGroup/${this.courseGroupId}`)
        this.courseGroup = content
        this.isThereSlots = this.courseGroup.isThereSlots
        this.courseGroups = [this.courseGroup]
      } catch (e) {

      }
    },

    async addStudent() {
      try {
        const body = {
          userId: this.user.id
        }
        const {content} = await this.apiService.post(`student`, body)
        this.student = content
      } catch (e) {

      }
    },

    async getStudent() {
      try {
        await this.apiService
            .get(`student/user/${this.user.id}`)
            .then(async (response) => {
              const {content} = response
              this.student = content
            })
            .catch(async (error) => {
              await this.addStudent()
            });
      } catch (error) {
      }
    },

    parseDate(date) {
      return FormatDate.momentDate(date)
    },

    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },

    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },

    formatCurrency(value) {
      return FormatCurrency.formatCurrency(value);
    },

    getDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },

    formatDaysOfTheWeek(daysOfTheWeek) {
      let daysOfTheWeekJson = JSON.parse(daysOfTheWeek)
      if (daysOfTheWeekJson.length === 1) {
        return this.getDaysOfTheWeek(daysOfTheWeekJson)
      }
      daysOfTheWeekJson = daysOfTheWeekJson.sort((x, y) => x - y)
      const isSequential = daysOfTheWeekJson.every((num, i) => i === 0 || num === daysOfTheWeekJson[i - 1] + 1)
      if (isSequential) {
        const [first] = daysOfTheWeekJson
        const last = daysOfTheWeekJson[daysOfTheWeekJson.length - 1]
        return `${this.getDaysOfTheWeek([first])} à ${this.getDaysOfTheWeek([last])}`
      }
      return this.getDaysOfTheWeek(daysOfTheWeekJson)
    },

    updateInstallmentValue(total) {
      this.parcelas.forEach((parcela) => {
        if (parcela.value > 10) {
          parcela.totalAmountOrdered = Number(total + this.calculateTotalInterestPerProduct(parcela.value))
          const valorParcela = Number(((total + this.calculateTotalInterestPerProduct(parcela.value)) / parcela.value).toFixed(2))
          parcela.name = `Em ${parcela.value}x com juros de ${this.taxaJuros}% A.M por ${valorParcela.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}`
        } else {
          parcela.totalAmountOrdered = Number(total)
          const valorParcela = Number((total / parcela.value).toFixed(2))
          parcela.name = `Em ${parcela.value}x sem juros por ${valorParcela.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}`
        }
      })
    },

    async removeCupon() {

    },

    async getCoupon() {

    },

    validateFields() {
      this.loading = true;
      if (!this.$refs.firstForm.validate()) {
        this.loading = false;
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Erro",
          message: "Preencha todos os campos!",
          trace: null,
        });
        return;
      }

      if (this.paymentMethod === this.creditCard) {
        PagarmeCheckout.init(this.success, this.fail);
      } else {
        this.buy();
      }
    },

    async buy() {
      try {
        this.loading = true;
        const body = {
          tokenCard: this.paymentMethod == '0' ? this.pagarmetokens['pagarmetoken-0'] : null,
          studentId: this.student.id,
          paymentMethod: this.paymentMethod,
          numberOfInstallments: this.creditInstallments,
          courseId: this.course.id,
          courseGroupId: this.courseGroupId
        }

        await this.apiService
            .post(`course/buy`, body)
            .then(async (response) => {
              const {content} = response
              this.orderCourse = content
              if(this.orderCourse.status == this.statusPaid || this.orderCourse.status == this.statusPending){
                await this.goToRouteOrder()
                return
              }
              this.$refs.firstForm.reset()
              this.$refs.firstForm.reset()
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "sucess",
                title: "Compra do curso concluída com sucesso!",
                message: "Compra do curso concluída com sucesso!",
                trace: null,
              });
              this.loading = false;
            })
            .catch((err) => {
              const message = err.body.message;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível concluir a compra!",
                message: message? message :"Não foi possível concluir a compra!",
                trace: null,
              });
              this.loading = false;
            });
      } catch (e) {

      }
    },


    async goToRouteOrder() {
      window.location.href= `${this.baseUrl}/cursos/checkout/status/${this.course.linkSearch}/${this.courseGroupId}/${this.orderCourse.id}`
    },

    calculateTotalInterestPerProduct(creditInstallments) {
      let installmentsInterest = 0
      if (this.paymentMethod === this.creditCard && Number(creditInstallments) > 10) {
        installmentsInterest += Number((Number((this.total * Math.pow(1 + this.taxaJuros / 100, creditInstallments)).toFixed(2)) - this.total).toFixed(2))
      }
      return Number(installmentsInterest.toFixed(2))
    },

    success(token) {
      this.pagarmetokens = token
      this.buy();
      return false;
    },

    fail(error) {
      this.loading = false;
      Vue.$globalEvent.$emit("onFlashMessage", {
        type: "error",
        title: "Erro",
        message: "Dados do cartão são inválidos!",
        trace: null,
      });
      return false;
    },

    async goToRoute(path) {
      await this.$router.push({
        path
      });
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },
  },
};
</script>
